import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Declare gtag on window for TypeScript
declare global {
  interface Window {
    gtag: (command: string, ...args: unknown[]) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-WT8JCN6PKN';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if gtag is available
    if (typeof window.gtag !== 'function') {
      return;
    }

    // Send page view event to GA4
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
};

// Helper function to track custom events
export const trackEvent = (
  eventName: string,
  parameters?: Record<string, unknown>
) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
  }
};
